/**
 * Fiskal Cloud Archive Export API
 * # Overview  Archive export API is used for * exporting imported assets in DSFinV-k cash register formats * exporting imported assets in RAW format - that means as they were imported  # Generic workflow  ## Export workflow We can export data via:  ``` curl \\ --request POST \\ --header \'Content-Type: application/json\' \\ --data-raw \'{\"exportType\": \"DSFINVK\", \"importIds\": [\"1\", \"2\"]}\' \\ https://fiskal.cloud/archiving-export-api/business-premises/{businessPremisesId}/exports ```  We receive `exportId`:  ``` {   \"id\": \"4dc75f64-5717-3214-b3fc-2c963f66aca7\" } ```  Then, we can keep polling the state until it\'s ready:  ``` curl \\ --request GET \\ https://fiskal.cloud/archiving-export-api/exports/4dc75f64-5717-3214-b3fc-2c963f66aca7 ```  ``` {   \"id\": \"3fa85f64-5717-4562-b3fc-2c963f66afa6\",   \"status\": \"PENDING\",   \"requested\": \"2020-04-20T11:47:05.471Z\" } ```  Once it\'s ready, we will get the URL where we can download the export: ``` {   \"id\": \"3fa85f64-5717-4562-b3fc-2c963f66afa6\",   \"status\": \"READY\",   \"requested\": \"2020-04-20T11:47:05.471Z\",   \"result\": {     \"url\": \"https://some-storage.lets-say.azure.com/storage/download-my-file\"   } } ``` 
 *
 * The version of the OpenAPI document: 0.18.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { CreateProceduralDocumentationExportBodyDTO } from '../model/create-procedural-documentation-export-body-dto';
// @ts-ignore
import { ExportStatusEnumDTO } from '../model/export-status-enum-dto';
// @ts-ignore
import { ProceduralDocumentationExportDTO } from '../model/procedural-documentation-export-dto';
// @ts-ignore
import { ProceduralDocumentationExportsResponseDTO } from '../model/procedural-documentation-exports-response-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import {
    ProceduralDocumentationExportsApiClientInterface,
    CreateProceduralDocumentationExportRequestParams,
    ExtendProceduralDocumentationExportRequestParams,
    ListProceduralDocumentationExportsRequestParams,
    ReadProceduralDocumentationExportRequestParams
} from './procedural-documentation-exports-api-client.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class ProceduralDocumentationExportsApiClient implements ProceduralDocumentationExportsApiClientInterface {

    protected basePath = 'https://fiskal.cloud/archiving-export-api';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Create procedural documentation export
     * Creates export. It\&#39;s possible to create export by selecting identifiers of documentations (e.g. &#x60;proceduralDocumentationIds&#x60;) or specific attributes (e.g. &#x60;validFrom&#x60; and &#x60;validTo&#x60;). 
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createProceduralDocumentationExport(requestParameters: CreateProceduralDocumentationExportRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<ProceduralDocumentationExportDTO>;
    public createProceduralDocumentationExport(requestParameters: CreateProceduralDocumentationExportRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<ProceduralDocumentationExportDTO>>;
    public createProceduralDocumentationExport(requestParameters: CreateProceduralDocumentationExportRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<ProceduralDocumentationExportDTO>>;
    public createProceduralDocumentationExport(requestParameters: CreateProceduralDocumentationExportRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const businessPremisesId = requestParameters.businessPremisesId;
        if (businessPremisesId === null || businessPremisesId === undefined) {
            throw new Error('Required parameter businessPremisesId was null or undefined when calling createProceduralDocumentationExport.');
        }
        const createProceduralDocumentationExportBodyDTO = requestParameters.createProceduralDocumentationExportBodyDTO;
        if (createProceduralDocumentationExportBodyDTO === null || createProceduralDocumentationExportBodyDTO === undefined) {
            throw new Error('Required parameter createProceduralDocumentationExportBodyDTO was null or undefined when calling createProceduralDocumentationExport.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (df_auth) required
        localVarCredential = this.configuration.lookupCredential('df_auth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/business-premises/${this.configuration.encodeParam({name: "businessPremisesId", value: businessPremisesId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/procedural-documentation-exports`;
        return this.httpClient.request<ProceduralDocumentationExportDTO>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: createProceduralDocumentationExportBodyDTO,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Extend the validity of export
     * Extend the validity of export which is related to export deletion
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public extendProceduralDocumentationExport(requestParameters: ExtendProceduralDocumentationExportRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<ProceduralDocumentationExportDTO>;
    public extendProceduralDocumentationExport(requestParameters: ExtendProceduralDocumentationExportRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<ProceduralDocumentationExportDTO>>;
    public extendProceduralDocumentationExport(requestParameters: ExtendProceduralDocumentationExportRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<ProceduralDocumentationExportDTO>>;
    public extendProceduralDocumentationExport(requestParameters: ExtendProceduralDocumentationExportRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const proceduralDocumentationExportId = requestParameters.proceduralDocumentationExportId;
        if (proceduralDocumentationExportId === null || proceduralDocumentationExportId === undefined) {
            throw new Error('Required parameter proceduralDocumentationExportId was null or undefined when calling extendProceduralDocumentationExport.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (df_auth) required
        localVarCredential = this.configuration.lookupCredential('df_auth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/procedural-documentation-exports/${this.configuration.encodeParam({name: "proceduralDocumentationExportId", value: proceduralDocumentationExportId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/extend`;
        return this.httpClient.request<ProceduralDocumentationExportDTO>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List procedural documentation export
     * Lists procedural documentation exports optionally by given filter
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listProceduralDocumentationExports(requestParameters: ListProceduralDocumentationExportsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<ProceduralDocumentationExportsResponseDTO>;
    public listProceduralDocumentationExports(requestParameters: ListProceduralDocumentationExportsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<ProceduralDocumentationExportsResponseDTO>>;
    public listProceduralDocumentationExports(requestParameters: ListProceduralDocumentationExportsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<ProceduralDocumentationExportsResponseDTO>>;
    public listProceduralDocumentationExports(requestParameters: ListProceduralDocumentationExportsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const businessPremisesId = requestParameters.businessPremisesId;
        if (businessPremisesId === null || businessPremisesId === undefined) {
            throw new Error('Required parameter businessPremisesId was null or undefined when calling listProceduralDocumentationExports.');
        }
        const createdDateFrom = requestParameters.createdDateFrom;
        const createdDateTo = requestParameters.createdDateTo;
        const status = requestParameters.status;
        const pageNumber = requestParameters.pageNumber;
        const pageSize = requestParameters.pageSize;
        const sort = requestParameters.sort;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (createdDateFrom !== undefined && createdDateFrom !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdDateFrom, 'createdDateFrom');
        }
        if (createdDateTo !== undefined && createdDateTo !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdDateTo, 'createdDateTo');
        }
        if (status) {
            status.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'status');
            })
        }
        if (pageNumber !== undefined && pageNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pageNumber, 'pageNumber');
        }
        if (pageSize !== undefined && pageSize !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pageSize, 'pageSize');
        }
        if (sort !== undefined && sort !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sort, 'sort');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (df_auth) required
        localVarCredential = this.configuration.lookupCredential('df_auth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/business-premises/${this.configuration.encodeParam({name: "businessPremisesId", value: businessPremisesId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/procedural-documentation-exports`;
        return this.httpClient.request<ProceduralDocumentationExportsResponseDTO>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Read procedural documentation export
     * Retrieves detail of procedural documentation export with given id
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public readProceduralDocumentationExport(requestParameters: ReadProceduralDocumentationExportRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<ProceduralDocumentationExportDTO>;
    public readProceduralDocumentationExport(requestParameters: ReadProceduralDocumentationExportRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<ProceduralDocumentationExportDTO>>;
    public readProceduralDocumentationExport(requestParameters: ReadProceduralDocumentationExportRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<ProceduralDocumentationExportDTO>>;
    public readProceduralDocumentationExport(requestParameters: ReadProceduralDocumentationExportRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const proceduralDocumentationExportId = requestParameters.proceduralDocumentationExportId;
        if (proceduralDocumentationExportId === null || proceduralDocumentationExportId === undefined) {
            throw new Error('Required parameter proceduralDocumentationExportId was null or undefined when calling readProceduralDocumentationExport.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (df_auth) required
        localVarCredential = this.configuration.lookupCredential('df_auth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/procedural-documentation-exports/${this.configuration.encodeParam({name: "proceduralDocumentationExportId", value: proceduralDocumentationExportId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<ProceduralDocumentationExportDTO>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
